export { ServicingPage } from './lib/servicing-page'
export { getStaticProps } from './lib/get-static-props'
export * from './lib/design-system/badge'
export { Image } from './lib/design-system/image'
export * from './lib/design-system/table/cell'
export * from './lib/design-system/table'
export { Table as StoryblokTable } from './lib/storyblok/table/table'
export { Table as StoryblokTableAdapter } from './lib/storyblok/table/table'
export type {
  StoryblokTableCell,
  StoryblokTableRow,
  TableProps as StoryblokTableProps,
} from './lib/storyblok/table/table'
export * from './lib/storyblok/table-section'

// Development-only, kept out of the component barrel so the badge folder
// stays portable to the design system.
export { BadgeGallery } from './lib/design-system/badge/badge.gallery'
